var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-interactjs',{attrs:{"widget":_vm.widget,"minw":100,"minh":30}},[_c('div',{staticClass:"outer"},[_c('div',{staticClass:"inner browser",style:({backgroundColor: _vm.widget.bc, textAlign: _vm.widget.a})},[_c('div',{staticClass:"top-bar"},[_c('div',{staticClass:"url",attrs:{"data-attribute":"text"}},[_vm._v(_vm._s(_vm.widget.t))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff47e72","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/WidgetBrowser.vue
// module id = 123
// module chunks = 0